export const environment = {
  production: true,
  nomeSistema: 'Core Base',
  api: 'http://apicorebase.servicosmsc.com.br',
  version: '1.0.0 - 20221113',
};
